<template>
  <router-view/>
</template>

<script>
  import RouteEntryMixin from '@com/mixins/route-entry'

  export default {
    name: 'requests',
    mixins: [RouteEntryMixin],
    data: _ => ({
      routes: [
        { path: '/requests/index', label: 'Requests' }
      ]
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/requests/Requests.Entry.vue